/*
 * @Author: DQL
 * @Date: 2020-03-16 14:32:26
 * @LastEditors: DQL
 * @LastEditTime: 2021-04-30 15:50:19
 * @Description: 菜单管理服务
 */
import axios from 'axios';
import config from '@/config';

const commontCtx = config.commontCtx;

// 获取菜单树
export const getMenuTree = () => { return axios.get(`${commontCtx}/menu/tree`); };

// 获取菜单详情信息
export const getMenu = (menuCode) => { return axios.get(`${commontCtx}/menu/get/${menuCode}`); };

// 新增菜单
export const addMenu = (params) => { return axios.post(`${commontCtx}/menu/save`, params); };

// 更新菜单
export const updateMenu = (params) => { return axios.put(`${commontCtx}/menu/update`, params); };

// 更新菜单
export const delMenu = (menuCode) => { return axios.delete(`${commontCtx}/menu/delete/${menuCode}`); };

// 获取业务系统列表
export const getAppList = () => { return axios.get(`${commontCtx}/app/list`); };

// 菜单排序
export const menuSort = (params) => { return axios.put(`${commontCtx}/menu/sort`, params); };
